import {ref} from "vue";

const fieldPool = ref(new Map());

export default function useFieldPool() {
  function bindFieldPool(poolName, field) {
    const fields = fieldPool.value.get(poolName) ?? [];
    fields.push(field);

    fieldPool.value.set(poolName, fields);
  }

  function invokeFieldChange(poolName) {
    const fields = fieldPool.value.get(poolName) ?? [];

    for (const field of fields) {
      field.validate();
    }
  }

  return {
    bindFieldPool,
    invokeFieldChange,
  };
};
